import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ResourceManagerWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;

require('../sass-main/pdc-widget-resource-manager.sass');

export class ResouceManagerWidget extends WidgetBase {
    public static _name: string = 'Resources';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-resource-manager';
    public static icon: string = 'cloud';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-resource-manager'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ResouceManagerWidget);
